import { PaymentType, CreditCardBrand } from 'src/types/dto';
import { isEmpty } from 'lodash';
import { useParams } from 'react-router-dom';
import { useEventContext } from '../../provider';
import {
  InvalidFieldName,
  useCartStore,
  useCheckoutFormValuesStore,
} from '../../stores';
import { CartItemType } from 'src/types/ui';
import { cpf } from 'cpf-cnpj-validator';
import useCellphoneValidation from '../hooks/useCellphoneValidate';

export const usePaymentForm = () => {
  const { eventID } = useParams();
  const { setInvalidFieldsNames, setInvalidFieldsMessage } = useEventContext();
  const { formValues } = useCheckoutFormValuesStore();
  const { getEventCart } = useCartStore();
  const isValidPhone = useCellphoneValidation()

  const trigger = () => {
    const invalidFieldsNames: InvalidFieldName[] = [];
    const invalidFieldsMessage: string[] = [];

    const fields = getEventCart(eventID!).reduce<CartItemType[]>(
      (acc, cartItem) => {
        if (cartItem.quantity) {
          const newAcc = [...acc];
          for (let index = 0; index < cartItem.quantity; index++) {
            newAcc.push(cartItem);
          }
          return newAcc;
        } else {
          return acc;
        }
      },
      [],
    );

    if (formValues.selectedPaymentType) {
      for (const [index, field] of fields.entries()) {
        const ownerKey = `${field.ticketTypeId}-${index}`;
        const owner = formValues.owners[ownerKey];
        const date = owner.buyerInfoData?.birth_date;
        const city = owner.buyerInfoData?.city;
        const state = owner.buyerInfoData?.state;

        // TESTES NO INPUT DE NOME
        if ((owner?.name?.trim()?.length ?? 0) === 0) {
          invalidFieldsNames.push(`fullName`);
          invalidFieldsMessage.push(`${ownerKey}: fullNameRequired`);
          continue;
        }

        if (
          !/^[A-zÀ-ú]{1,40}(?: +[A-zÀ-ú]{1,40})+$/.test(owner?.name?.trim())
        ) {
          invalidFieldsNames.push('fullName');
          invalidFieldsMessage.push(`${ownerKey}: fullNameRequired`);
          continue;
        }

        // TESTE NOS INPUTS QUANDO HOUVER BUYERDATAINFO
        if (owner?.buyerInfoData) {
          // TESTE NO INPUT DE DATA
          if (date === undefined) {
            invalidFieldsNames.push('bornAt');
            invalidFieldsMessage.push(`${ownerKey}: dateRequired`);
            continue;
          } else {
            const splitedTypeDate = date.split('-');
            const dayTyped = Number(splitedTypeDate[2]);
            const monthTyped = Number(splitedTypeDate[1]);

            if (dayTyped > 31 || dayTyped <= 0) {
              invalidFieldsNames.push('bornAt');
              invalidFieldsMessage.push(`${ownerKey}: dateRequired`);
              continue;
            }

            if (monthTyped > 12 || monthTyped <= 0) {
              invalidFieldsNames.push('bornAt');
              invalidFieldsMessage.push(`${ownerKey}: dateRequired`);
              continue;
            }
          }

          // TESTE NO INPUT DE CIDADE
          if (city === '') {
            invalidFieldsNames.push('city');
            invalidFieldsMessage.push(`${ownerKey}: cityRequired`);
            continue;
          }

          // TESTE NO INPUT DE ESTADO
          if (state === '') {
            invalidFieldsNames.push('state');
            invalidFieldsMessage.push(`${ownerKey}: stateRequired`);
            continue;
          }
        }
      }
    }

    if (formValues.selectedPaymentType === PaymentType.CreditCard) {
      if (isEmpty(formValues.selectedCardCvv.trim())) {
        invalidFieldsNames.push('selectedCardCvv');
        invalidFieldsMessage.push(
          'Preencha o código de segurança do cartão selecionado',
        );
      } else if (
        formValues.selectedCardCvv.trim().length !==
        (formValues.selectedCardBrand === CreditCardBrand.Amex ? 4 : 3)
      ) {
        invalidFieldsNames.push('selectedCardCvv');
        invalidFieldsMessage.push('Código de segurança Inválido');
      }
    }

    if (formValues.selectedPaymentType === PaymentType.Pix) {
      if (formValues.isDocumentRequired && !cpf.isValid(formValues.payerCpf)) {
        invalidFieldsNames.push('payerCpf');
        invalidFieldsMessage.push('CPF Inválido');
      }
    }

    if (
      (formValues.selectedPaymentType === PaymentType.Pix &&
        formValues.isPhoneRequired &&
        !isValidPhone(formValues.payerPhone))
    ) {
      invalidFieldsNames.push('payerPhone');
      invalidFieldsMessage.push('Telefone inválido');
    }

    setInvalidFieldsNames?.(invalidFieldsNames);
    setInvalidFieldsMessage?.(invalidFieldsMessage);

    return invalidFieldsNames.length === 0;
  };

  return { trigger, values: formValues };
};
